export const API_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:4000/api/v1"
    : "https://newneoncapbe-production.up.railway.app/api/v1";
